import React from "react";
import { formErrorHandler } from "../forms/util";
import { BackboneModel, GeometryModel } from "./cropr";
import { gettext, interpolate } from "./legacy";
import { Formik, FormikConfig } from "formik";

export type PropertiesModalProps<Model extends GeometryModel> = {
  model: Model;
  onSave?: (storage: any) => void;
  onHide?: () => void;
  requiredSubAttrs?: any;
};

type ModelSubmitFormikProperties<Model extends GeometryModel> = {
  model: Model;
  collection: Backbone.Collection;
  onSave?: (model: Model) => void;
  hide: () => void;
  typeName: string;
  beforeSave?: (values: any) => any;
};
type NoSubmitFC<Values> = Omit<FormikConfig<Values>, "onSubmit">;

export const ModelSubmitFormik = ({
  model,
  hide,
  onSave,
  typeName,
  collection,
  beforeSave,
  ...props
}: ModelSubmitFormikProperties<GeometryModel> & NoSubmitFC<any>) => (
  <Formik
    {...props}
    onSubmit={(values, actions) =>
      model.saveAndAddNewTo(
        collection,
        beforeSave ? beforeSave(values) : values,
        function () {
          // success
          hide();
          onSave && onSave(model);
        },
        formErrorHandler<BackboneModel>(
          interpolate(gettext("Can not save %s. Please check input."), [typeName]),
          actions
        )
      )
    }
  />
);
